import { Action } from "redux";

export type ReviztoAccessTokenDialogDismissedEvent = Action<typeof REVIZTO_ACCESS_TOKEN_DIALOG_DISMISSED>

const reviztoAccessTokenDialogDismissedEvent = (): ReviztoAccessTokenDialogDismissedEvent => ({
  type: REVIZTO_ACCESS_TOKEN_DIALOG_DISMISSED
});

export const REVIZTO_ACCESS_TOKEN_DIALOG_DISMISSED = "revizto_access_token_dialog_dismissed";

export default reviztoAccessTokenDialogDismissedEvent;